const adSystemSources = [
  'adfox',
  'admitad',
  'adnews',
  'adnous',
  'adriver',
  'advmaker',
  'aport',
  'aport.ru',
  'AvitoPromo',
  'AvitoContext',
  'begun',
  'bing',
  'B2BContext',
  'criteo',
  'directadvert',
  'directadvert.ru',
  'drivenetwork',
  'facebook',
  'fb',
  'facebook.com',
  'fb.com',
  'giraffio',
  'google',
  'adwords',
  'adsense',
  'instagram',
  'kavanga',
  'ladycenter',
  'link',
  'magna',
  'marketgid',
  'medialand',
  'merchant',
  'moimir',
  'nnn',
  'nnn.ru',
  'odnoklassniki',
  'price',
  'price.ru',
  'prre',
  'mytarget',
  'targetmailru',
  'taboola',
  'torg.mail.ru',
  'trorer',
  'rorer',
  'Ttarget',
  'ubn.ua',
  'banner.ua',
  'videonow',
  'vkontakte',
  'vk',
  'vk.com',
  'whisla',
  'youtube',
];
const adSystemMediums = [
  'cpc',
  'ppc',
  'paidsearch',
  'cpv',
  'cpa',
  'cpp',
  'display',
  'cpm',
  'banner',
];

const extractHostname = (url) => {
  if (!url) return '';

  let hostname;

  if (url.includes('://')) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }

  hostname = hostname.split(':')[0];
  hostname = hostname.split('?')[0];
  hostname = hostname.replace(/^www\./, '').replace('#', '');

  return hostname;
};

const parseUrlParameters = (url, delimiter) => {
  const params = {};
  const queryParams = url.split(delimiter)[1]?.split('&') || [];

  queryParams.forEach((item) => {
    const [key, value] = item.split('=');
    if (key) {
      params[key] = value || '';
    }
  });

  return params;
};

export const getValueFromUrl = (url, key) => {
  if (url && url.includes(`${key}=`)) {
    const regexp = new RegExp(`https?://.*${key}=([^&]*)`);
    const valueFromURL = url.match(regexp);

    if (valueFromURL && valueFromURL.length > 1) {
      return valueFromURL[1];
    }
  }
  return null;
};

const parseUrlSearchParameters = (url) => {
  return parseUrlParameters(url, '?');
};

const parseUrlHashParameters = (url) => {
  return parseUrlParameters(url, '#');
};

export const getDocumentCharset = () => {
  return (document.characterSet || document.charset || '').toLowerCase();
};

export const getRootElement = () => {
  const a = document.documentElement;
  return document.compatMode === 'CSS1Compat' ? a : document.body || a;
};

export const getViewportSize = () => {
  const a = getRootElement();
  return [
    a.clientWidth || window.innerWidth,
    a.clientHeight || window.innerHeight,
  ];
};

export const getDocumentTitle = () => {
  let title = document.title;
  if (typeof title !== 'string') {
    const titleElements = document.getElementsByTagName('title');
    title = titleElements.length ? titleElements[0].innerHTML : '';
  }
  return title;
};

export const getUtmParameters = () => {
  const utmParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const queryParams = parseUrlSearchParameters(window.location.search);
  const utmValues = {};

  utmParameters.forEach((param) => {
    utmValues[param] = queryParams[param] || null;
  });

  return utmValues;
};

export const isFromAd = () => {
  if (!document.referrer) {
    return false;
  }

  const params = {
    ...parseUrlSearchParameters(window.location.search),
    ...parseUrlHashParameters(window.location.hash),
  };

  for (const [key, value] of Object.entries(params)) {
    if (
      (key === 'utm_source' && adSystemSources.includes(value)) ||
      (key === 'utm_medium' && adSystemMediums.includes(value))
    ) {
      return true;
    }
  }

  return false;
};

export const isExternal = (siteDomains, linkUrl) => {
  const hostname = extractHostname(linkUrl);
  if (typeof hostname === 'string') {
    return !siteDomains.includes(hostname);
  }
  return false;
};

export const isInternal = (siteDomains, linkUrl) => {
  const hostname = extractHostname(linkUrl);
  const currHostname = extractHostname(window.location.hostname);

  if (typeof hostname === 'string') {
    return hostname === currHostname || siteDomains.includes(hostname);
  }

  return false;
};
